
// Launched on Nov (11 => index in the array is 10) 20, 1998
const time = (Date.now() - new Date(1998, 10, 20)) / (1000 * 60 * 60 * 24);
const timeSentinel6 = (Date.now() - new Date(2020, 10, 10)) / (1000 * 60 * 60 * 24);

const SPACECRAFT_DATA = {
	ISS: {
		absolutePath: true,
		thumb: 'assets/images/iss_320x240.jpg',
		url: 'https://www.nasa.gov/mission_pages/station/main/index.html',
		id: 1374,
		target: '_blank',
		categories: ['operating', 'land', 'earth_now'],
		time_in_orbit: Math.floor(Math.abs(time) / 365.25) + ' years : ' + Math.floor(time % 365.25) + ' day' + (Math.floor(time % 365.25) > 1 ? 's' : ''),
		description: 'The International Space Station (ISS) is a space station, or a habitable artificial satellite, in low Earth orbit. Its first component was launched into orbit in 1998, with the first long-term residents arriving in November 2000. It has been inhabited continuously since that date. The last pressurized module was fitted in 2011, and an experimental inflatable space habitat was added in 2016. The station is expected to operate until 2030. Development and assembly of the station continues, with several new elements scheduled for launch in 2019. The ISS is the largest human-made body in low Earth orbit and can often be seen with the naked eye from Earth. The ISS consists of pressurized habitation modules, structural trusses, solar arrays, radiators, docking ports, experiment bays and robotic arms. ISS components have been launched by Russian Proton and Soyuz rockets and American Space Shuttles. The ISS program is a joint project between five participating space agencies: NASA (United States), Roscosmos (Russia), JAXA (Japan), ESA (Europe), and CSA (Canada). The ownership and use of the space station is established by intergovernmental treaties and agreements.</br></br>The ISS serves as a microgravity and space environment research laboratory in which crew members conduct experiments in biology, human biology, physics, astronomy, meteorology, and other fields. The station is suited for the testing of spacecraft systems and equipment required for missions to the Moon and Mars. The ISS maintains an orbit with an altitude of between 330 and 435 km (205 and 270 mi) by means of reboost maneuvers using the engines of the Zvezda module or visiting spacecraft. It circles the Earth in roughly 92 minutes and completes 15.5 orbits per day.',
		title: 'International Space Station',
		external_id: 'ISS',
		date: 'November 20, 1998',
		launch_location: 'Baikonur Cosmodrome, Kazhakstan',
		launch_vehicle: 'Russian Proton rocket'
	},
	Sentinel6: {
		absolutePath: true,
		thumb: 'assets/images/sentinel_6_320x240.jpg',
		url: 'https://www.nasa.gov/mission_pages/station/main/index.html',
		id: 1375,
		target: '_blank',
		categories: ['operating', 'sea', 'earth_now'],
		time_in_orbit: Math.floor(Math.abs(timeSentinel6) / 365.25) + ' years : ' + Math.floor(timeSentinel6 % 365.25) + ' day' + (Math.floor(timeSentinel6 % 365.25) > 1 ? 's' : ''),
		description: 'The first of two identical satellites to be launched five years apart, Sentinel-6 Michael Freilich will make high precision ocean altimetry measurements to continue the work previously done by Jason-1, Jason-2/OSTM, and the Jason-3 missions.\n\nA secondary objective is to collect high resolution vertical profiles of temperature and water vapor through the Radio Occultation instrument. This is used to help numerical weather predictions.',
		title: 'Sentinel-6 Michael Freilich',
		external_id: 'Sentinel6',
		date: 'November 10, 2020',
		launch_location: 'Vandenberg Air Force Base',
		launch_vehicle: ''
	},
	// Foo: {
		// absolutePath: true,
		// thumb: 'assets/images/iss_320x240.jpg',
		// url: 'https://www.nasa.gov/mission_pages/station/main/index.html',
		// id: 1376,
		// target: '_blank',
		// categories: ['operating', 'land', 'earth_now'],
		// time_in_orbit: '900 days',
		// description: 'Ut leo. Mauris sollicitudin fermentum libero. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Proin magna.',
		// title: 'Foo',
		// external_id: 'foo',
		// date: 'May 3, 2019',
		// launch_location: '',
		// launch_vehicle: ''
	// },
	// sc_saudisat_4: {
		// absolutePath: true,
		// clickable: true,
		// thumb: 'assets/images/iss_320x240.jpg',
		// url: 'https://www.nasa.gov/mission_pages/station/main/index.html',
		// id: 1,
		// target: '_blank',
		// categories: ['operating', 'land', 'earth_now'],
		// time_in_orbit: '900 days',
		// description: 'Ut leo. Mauris sollicitudin fermentum libero. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Proin magna.',
		// title: 'SAUDISAT 1C',
		// external_id: 'sc_saudisat_4',
		// date: 'May 3, 2019',
		// launch_location: '',
		// launch_vehicle: ''
	// }
	
};

export default SPACECRAFT_DATA;
